export default __webpack_public_path__ + "static/media/Velocity-Logo-white-orange-transparent.9ed586fa.png";